import UserData, {UserGroup} from '../shared/model/UserData';

const isUserInGroup = (userData: UserData, group: UserGroup): boolean => userData && userData.userGroup === group;

export const checkIfProspect = (userData: UserData): boolean => isUserInGroup(userData, UserGroup.PROSPECT);
export const checkIfNotProspect = (userData: UserData): boolean => userData && userData.userGroup !== UserGroup.PROSPECT;
export const checkIfCustomer = (userData: UserData): boolean => isUserInGroup(userData, UserGroup.CUSTOMER);
